import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Lazy initializer, not a hard-coded `false`: this is a client-only SPA
  // (no SSR), so `window` is always available at first render. Defaulting to
  // `false` and correcting in an effect one tick later made every consumer
  // briefly render the desktop branch on a phone before swapping — for a
  // consumer that mounts something expensive/one-shot on that branch (e.g.
  // DocumentPreview's pdf case, spec 2026-09-16-05), that flash is a real
  // blank-box-then-swap, not just a cosmetic flicker.
  const [isMobile, setIsMobile] = useState<boolean>(() => window.innerWidth < MOBILE_BREAKPOINT)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}